import React from 'react';
import { Box, MissingDetailIcon, StepDoneIcon, Text, TextExtendedProps } from '@common-fe/common-fe';

interface Props {
  testId: string;
  hasValue?: boolean;
  title?: string;
  titleProps?: TextExtendedProps;
  subTitle?: string;
  isMobile?: boolean;
}

const FieldSetupLabel: React.FC<Props> = ({ testId, hasValue, title, titleProps, subTitle, isMobile }) => {
  return (
    <Box
      data-testId={`${testId}-field-setup-label`}
      margin={{ left: isMobile ? 'spacing8' : undefined }}
    >
      <Box direction={isMobile ? 'row' : 'column'} {...isMobile ? { align: 'center' } : {}}>
        {hasValue ? (
          <StepDoneIcon
            data-testid={`${testId}-field-setup-label_has-value-icon`}
            size="32px"
          />
        ) : (
          <MissingDetailIcon
            data-testid={`${testId}-field-setup-label_missing-value-icon`}
            color="missingDetail"
            size="32px"
          />
        )}
        <Text
          data-testId={`${testId}-field-setup-label_title`}
          margin={{
            top: isMobile ? undefined : 'spacing24',
            left: isMobile ? 'spacing8' : undefined,
          }}
          weight={700}
          size={isMobile ? '2xl' : '3xl'}
          {...titleProps}
        >
          {title}
        </Text>
      </Box>
      {subTitle ? (
        <Text
          data-testId={`${testId}-field-setup-label_sub-title`}
          margin={{
            top: isMobile ? 'spacing12' : 'spacing2',
          }}
        >
          {subTitle}
        </Text>
      ) : null}
    </Box>
  );
};

export default FieldSetupLabel;
